import loadable from '@loadable/component';

export const DialogOverlay = loadable(
  () => import(/* webpackChunkName: 'dialog-overlay' */ './DialogOverlay'),
);
